import { Switch } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';

import type User from 'stores/User';

export interface UserActivationSwitchProps {
  user: User;
}

function UserActivationSwitch({ user }: UserActivationSwitchProps) {
  return (
    <div>
      <Switch checked={user?.data.activated} onClick={user.toggleActivated} />
    </div>
  );
}

export default observer(UserActivationSwitch);
